import pt from '@/internationalization/trans/chefs/pt/pt.json';
export default {
  trans: pt,
};
